import {getImagesAndFiles} from "../../api/file/FileService";

export const EMPTY_ATTACH_STATE = {
    existingDocs: [],
    existingImages: [],
    pendingDocs: [],
    pendingImages: [],
    removedFileIds: [],
    removedImageIds: [],
};

export async function loadAttachState(tableName, joinKey, options = {}) {
    const {withImages = true} = options;

    const docRes = await getImagesAndFiles(tableName, joinKey, "FILE");
    let existingImages = [];

    if (withImages) {
        const imgRes = await getImagesAndFiles(tableName, joinKey, "IMG");
        existingImages = imgRes?.status === 200 ? imgRes.data ?? [] : [];
    }

    return {
        existingDocs: docRes?.status === 200 ? docRes.data ?? [] : [],
        existingImages,
        pendingDocs: [],
        pendingImages: [],
        removedFileIds: [],
        removedImageIds: [],
    };
}

/** AssetRequestDto — 백엔드 PUT /assets/{id} multipart JSON 파트 */
export function buildAssetRequestDto(asset, attachState) {
    const dto = {
        id: asset.id,
        assetName: asset.assetName,
        assetCode: asset.assetCode ?? null,
        group: asset.group ?? null,
        task: asset.task ?? null,
        location: asset.location ?? null,
        slaGroup: asset.slaGroup ?? null,
        department: asset.department ?? null,
        project: asset.project ?? null,
        operator: asset.operator ?? [],
        handler: asset.handler ?? [],
        etc: asset.etc ?? null,
        mngPrimary: asset.mngPrimary ?? null,
        mngSecondary: asset.mngSecondary ?? null,
        mngTertiary: asset.mngTertiary ?? null,
        importDate: asset.importDate ?? null,
        importPrice: asset.importPrice != null && asset.importPrice !== "" ? String(asset.importPrice) : null,
        mngPrice: asset.mngPrice != null && asset.mngPrice !== "" ? String(asset.mngPrice) : null,
        mngRate: asset.mngRate != null && asset.mngRate !== "" ? String(asset.mngRate) : null,
        endOfService: asset.endOfService ?? null,
        involvedIntoCompose: asset.involvedIntoCompose ?? false,
        isRemoved: asset.isRemoved ?? false,
        assetFields: asset.assetFields ?? [],
        assetCustomCodes: asset.assetCustomCodes ?? [],
        assetCustomStrings: asset.assetCustomStrings ?? [],
    };

    if (attachState?.removedImageIds?.length) {
        dto.deletedImageIds = attachState.removedImageIds;
    }
    if (attachState?.removedFileIds?.length) {
        dto.deletedFileIds = attachState.removedFileIds;
    }

    return dto;
}

export function getPendingUploadFiles(attachState) {
    return {
        images: (attachState?.pendingImages ?? []).map((item) => item.object).filter(Boolean),
        files: (attachState?.pendingDocs ?? []).map((item) => item.object).filter(Boolean),
    };
}

export function getVisibleDocs(attachState) {
    if (!attachState) return [];
    const removed = new Set(attachState.removedFileIds ?? []);
    const existing = (attachState.existingDocs ?? []).filter((item) => !removed.has(item.id));
    return [...existing, ...(attachState.pendingDocs ?? [])];
}

export function getVisibleImages(attachState) {
    if (!attachState) return [];
    const removed = new Set(attachState.removedImageIds ?? []);
    const existing = (attachState.existingImages ?? []).filter((item) => !removed.has(item.id));
    return [...existing, ...(attachState.pendingImages ?? [])];
}

export function removeAttachItem(setAttachState, item, kind) {
    if (!item) return;

    setAttachState((prev) => {
        if (!prev) return prev;

        if (item.object) {
            if (kind === "doc") {
                return {
                    ...prev,
                    pendingDocs: prev.pendingDocs.filter((doc) => doc.id !== item.id),
                };
            }
            return {
                ...prev,
                pendingImages: prev.pendingImages.filter((img) => img.id !== item.id),
            };
        }

        if (item.id == null) return prev;

        if (kind === "doc") {
            return {
                ...prev,
                removedFileIds: prev.removedFileIds.includes(item.id)
                    ? prev.removedFileIds
                    : [...prev.removedFileIds, item.id],
            };
        }

        return {
            ...prev,
            removedImageIds: prev.removedImageIds.includes(item.id)
                ? prev.removedImageIds
                : [...prev.removedImageIds, item.id],
        };
    });
}
